import lodashGet from 'lodash/get';

let translation = {};

/**
 * Check if key of object home24.translate exists and translate it
 * @function
 * @param {String} key text to translate
 * @returns {String} the key translation if key exists otherwise the key
 */
export function get(key) {
  return lodashGet(translation, key, key);
}

export function setTranslations(t) {
  translation = t;
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/core/translation.js
 **/